// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import axios from 'axios'

import VueHighcharts from 'vue-highcharts'
import Highcharts from 'highcharts'
import loadMap from 'highcharts/modules/map.js';
import loadDrillDown from 'highcharts/modules/drilldown'
import VueBootstrapToasts from "vue-bootstrap-toasts"
import fullscreen from 'vue-fullscreen'
import * as VueGoogleMaps from 'vue2-google-maps'
import MarqueeText from 'vue-marquee-text-component'
import iView from 'iview'
import locale from 'iview/dist/locale/en-US';


Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_API,
    libraries: "places" // necessary for places input
  }
});

Vue.use(iView, {locale: locale});
Vue.use(fullscreen)
Vue.use(VueBootstrapToasts)
Vue.use(BootstrapVue)
// Vue.use(Axios)
loadMap(Highcharts)
loadDrillDown(Highcharts)
Vue.use(Highcharts)
Vue.use(VueHighcharts, { Highcharts })
Vue.component('marquee-text', MarqueeText)

const Axios = axios.create({
  baseURL: process.env.VUE_APP_TRACKER_URL
})

Axios.interceptors.request.use(
  config => {
    config.headers.common["Content-Type"] = "application/x-www-form-urlencoded";
    config.headers.common["Accept"] = "application/json";
    const token = localStorage.getItem("aoi_token");
    if (token) {
      config.headers.common["Authorization"] = token;
    } else {
      config.headers.common["Authorization"] = "";
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
Axios.interceptors.response.use((response) => {
  if(response.status === 206) {
    window.location.href = process.env.VUE_APP_TRACKER_URL
  }
  return response;
}, (error) => {
  if (error.response && error.response.data) {
    return Promise.reject(error.response.data);
  }
  return Promise.reject(error.message);
});
Vue.prototype.$http = Axios;

Vue.prototype.$formatUSDate = (date) => {
  return date ? date.slice(5, 7) + '/' + date.slice(8, 10) + '/' + date.slice(0, 4) : null
}

Vue.prototype.$currentYear = () => {
  const createStart = new Date();
  const startingYear = createStart.getFullYear()
  return startingYear + "-01-01";
}

Vue.prototype.$trackerBase = process.env.VUE_APP_TRACKER_BASE

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  }
})
